<template>
    <div class="layout-wp">
        <com-top-header></com-top-header>
        <com-header :type="2"></com-header>
        <com-menu></com-menu>
        <div class="m-main">
            <router-view/>
        </div>
        <com-footer></com-footer>
    </div>
    
</template>
<script>
import Layout from './Layout.js';
export default Layout;
</script>
<style lang="scss" scoped>
.layout-wp{
    width:100%;
    height:100%;
}
.com-menu{
    width:100%;
    height:50px;
    background:#056BD1;
}
.m-main{
    width:100%;
    height:auto;
    min-height:800px;
    padding-bottom:10px;
}
</style>